__turbopack_context__.v({
  "range_controls": "input-range-slider-module-scss-module__RITAiW__range_controls",
  "range_controlsDivider": "input-range-slider-module-scss-module__RITAiW__range_controlsDivider",
  "range_controlsInput": "input-range-slider-module-scss-module__RITAiW__range_controlsInput",
  "range_input": "input-range-slider-module-scss-module__RITAiW__range_input",
  "slider_input": "input-range-slider-module-scss-module__RITAiW__slider_input",
});
